module.exports = __webpack_public_path__ + "/images/shop/icon/menu--light-blue.svg";